export default __webpack_public_path__ + "static/media/contactwavebtm.f0f77d45.png";